const Footer = () => {
  return (
    <footer className="flex-auto  w-full px-2 py-4 bg-gray-100 dark:bg-gray-700 sm:px-4 shadow-xl">
      <span className="flex justify-end text-black dark:text-white">
        &copy; A project by sinfulpriderhitta
      </span>
    </footer>
  )
}

export default Footer
